var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCoin = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 21,
  viewBox: "0 0 20 21",
  fill: "none",
  ref: svgRef
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M16.3549 16.0868C19.8819 12.6218 19.8819 7.06277 16.3549 3.59777C12.8279 0.132773 7.17088 0.132773 3.64488 3.59777C0.118875 7.06277 0.117875 12.6218 3.64488 16.0868",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M2.1001 20H18.1001H2.1001V20Z",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M10 5V6.25",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  d: "M10 15V13.75",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_5",
  d: "M12.487 8C12.422 7.024 11.617 6.25 10.625 6.25H9.255C8.285 6.25 7.5 7.036 7.5 8.005C7.5 8.81 8.048 9.512 8.828 9.708L11.171 10.296C11.952 10.492 12.499 11.194 12.499 11.999C12.499 12.969 11.713 13.754 10.744 13.754H9.374C8.38 13.754 7.575 12.978 7.511 12",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCoin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/coin.a5ebdef4.svg";
export { ForwardRef as ReactComponent };